export const calcularEdad = (fechaNacimiento) => {
  if (!fechaNacimiento) return '';
  const hoy = new Date();
  const nacimiento = new Date(fechaNacimiento);
  let edad = hoy.getFullYear() - nacimiento.getFullYear();
  const mes = hoy.getMonth() - nacimiento.getMonth();
  if (mes < 0 || (mes === 0 && hoy.getDate() < nacimiento.getDate())) {
    edad--;
  }
  
  if (edad < 1) {
    const meses = mes < 0 ? 12 + mes : mes;
    return `${meses} ${meses === 1 ? 'mes' : 'meses'}`;
  }
  
  return `${edad} ${edad === 1 ? 'año' : 'años'}`;
};

export const formatearFecha = (fecha) => {
  if (!fecha) return '';
  return new Date(fecha).toLocaleDateString('es-AR');
};

export const formatearHorario = (inicio, fin) => {
  if (!inicio || !fin) return '-';
  const horaInicio = new Date(inicio).toLocaleTimeString('es-AR', { 
    hour: '2-digit', 
    minute: '2-digit', 
    hour12: false 
  });
  const horaFin = new Date(fin).toLocaleTimeString('es-AR', { 
    hour: '2-digit', 
    minute: '2-digit', 
    hour12: false 
  });
  return `${horaInicio} - ${horaFin}`;
};

export const getDateRange = (daysBack, daysForward) => {
  const desde = new Date(Date.now() - daysBack * 24 * 60 * 60 * 1000)
    .toISOString().split('T')[0];
  const hasta = new Date(Date.now() + daysForward * 24 * 60 * 60 * 1000)
    .toISOString().split('T')[0];
  return { desde, hasta };
};

export const getColorPrioridad = (fechaEntrega, solicitado, colors) => {
  if (!fechaEntrega || solicitado === 'S') return null;
  
  const hoy = new Date();
  hoy.setHours(0, 0, 0, 0);
  const fechaEnt = new Date(fechaEntrega);
  fechaEnt.setHours(0, 0, 0, 0);
  const manana = new Date(hoy);
  manana.setDate(manana.getDate() + 1);
  
  if (fechaEnt <= hoy) return colors.VENCIDO;
  if (fechaEnt.getTime() === manana.getTime()) return colors.VENCE_MANANA;
  return null;
};
